import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { IMAGEM_LOGO_CENTRUS_BASE64 } from '../../../../../../app.constants';
import { BeneficioPropDiferidoModel } from '../../../../models/beneficio-prop-diferido.model';
import { PessoaDadosSimplicadosModel } from '../../../../models/pessoa-simplificada.model';
import { CpfPipe } from '../../../../pipe/cpf-pipe';
import { FormateNumberZeroPipe } from '../../../../pipe/format-number-zero.pipe';

@Injectable()
export class BPDPdf {

  constructor(
    private _decimalPipe: DecimalPipe,
    private _formateNumberZeroPipe: FormateNumberZeroPipe,
    private _cpf: CpfPipe
  ) { }

  public funcionarios(pessoaDadosSimplicadosModel: PessoaDadosSimplicadosModel, beneficioPropDiferidoModel: Array<BeneficioPropDiferidoModel>) {

    const doc = new jsPDF('p', 'mm', 'a4');

    doc.addImage(IMAGEM_LOGO_CENTRUS_BASE64, 'PNG', 90, 20, 30, 20);
    doc.setFontSize(13);
    doc.setFont('Source Sans Pro');
    doc.setFontStyle('bold');
    doc.text(`Benefécio Proporcional Diferido - BPD`, 70, 50)

    doc.autoTable({
      startY: 60
    })

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 9,
      },
      head: [[`Plano de Benefício Definido Centrus - PBDC `, `CNPB: 2011.0008-74`]]
    });

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 8,
      },
      styles: {
        fontSize: 8
      },
      columnStyles: {
        0: { cellWidth: 30 }
      },
      head: [['CPF', 'Nome']],
      body: [[this._cpf.transform(pessoaDadosSimplicadosModel.cpf), pessoaDadosSimplicadosModel.nome]],
    });

    doc.autoTable({
      theme: 'plain',
      headStyles: {
        fillColor: [226, 235, 248],
        fontSize: 8,
      },
      footStyles: {
        fillColor: [226, 235, 248],
      },
      styles: {
        fontSize: 8
      },
      head: this._headRows(),
      body: this._bodyRows(beneficioPropDiferidoModel)
    });

    doc.setFontSize(8);
    doc.setFont('Source Sans Pro');
    doc.text(` Reserva decorrente do Instituto do Benefécio Proporcional Diferido - BPD - art. 39 do Regulamento do PBDC.`, 14, doc.previousAutoTable.finalY + 8);


    doc.setProperties({
      title: 'Consulta BPD',
      subject: `Consulta Benefício Propocional Diferido`,
      author: 'centrus',
      keywords: 'generated, javascript, web 2.0, ajax',
      creator: 'Fundação Banco central de previcência provida - centrus'
    });

    (window.innerWidth > 640)
      ? (window.open(URL.createObjectURL(doc.output('blob'))))
      : this.handleFile(doc.output('blob'), 'bpd.pdf');
  }

  handleFile(res: any, fileName: string) {
    const file = new Blob([res], {
      type: res.type
    });

    // IE
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(file);
      return;
    }



    const blob = window.URL.createObjectURL(file);

    const link = document.createElement('a');
    link.href = blob;
    link.download = fileName;

    // link.click();
    link.dispatchEvent(new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    }));

    setTimeout(() => { // firefox
      window.URL.revokeObjectURL(blob);
      link.remove();
    }, 100);
  }


  private _bodyRows(beneficioPropDiferidoModel: Array<BeneficioPropDiferidoModel>) {
    const body = []

    beneficioPropDiferidoModel.map(item => {
      body.push({
        data: item.dtReferencia,
        event: item.dsOcorrencia,
        valor: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlOcor, '1.1-2')),
        saldo: this._formateNumberZeroPipe.transform(this._decimalPipe.transform(item.vlSaldo, '1.1-2'))
      })
    })
    return body;
  }

  private _headRows() {
    return [{
      data: 'Mês/Ano',
      event: 'Evento',
      valor: 'Valor',
      saldo: 'Saldo'
    },
    ]
  }






}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/shared/services/documentos-pdf-imprimir/Plano/beneficio-proprio-diferido/bpd-pdf.ts